<script>
import { mapGetters } from 'vuex'
import Dropdown from '@/components/atoms/Dropdown'
import Box from '@/components/atoms/Box'
import ModalLogout from '@/components/organism/modal/ModalLogout'
import ProfileNav from '@/components/molecules/ProfileNav'
import { EventBus } from '@/modules/plugins/modules/event'
import LanguageSelector from '@/components/molecules/LanguageSelector'

export default {
    name: 'HeaderUser',
    components: {
        LanguageSelector,
        ModalLogout,
        Box,
        Dropdown,
        ProfileNav,
    },
    data() {
        return {
            showLanguageSelector: false,
        }
    },
    computed: {
        ...mapGetters(['locales', 'locale', 'smDevice', 'languageSelectorAvailable']),
        user() {
            return this.isLoggedIn ? this.$user.model : null
        },
        isLoggedIn() {
            return this.$user.isLoggedIn
        },
        authPage() {
            return this.$route.meta.auth
        },
        adminPortal() {
            return this.user?.user_is_admin
                ? `${process.env.VUE_APP_ADMIN_PORTAL}login-token?token=${this.$user.client.dataStorage.refreshToken}`
                : null
        },
    },
    methods: {
        setLanguage(locale) {
            this.$refs.dropdown?.close()
            this.$store.dispatch('localeSet', locale).finally(() => {
                EventBus.$emit('language')
            })
        },
        onClose() {
            this.showLanguageSelector = false
        },
        logout() {
            this.close()
            this.$refs.logout.open()
        },
        close() {
            if (this.smDevice) EventBus.$emit('closeDropdown')
        },
        goToAdminPortal() {
            if (this.adminPortal) {
                window.open(this.adminPortal, '_blank')
                this.close()
            }
        },
    },
}
</script>

<template lang="pug">
transition(name="fade" :key="`headerUser-${authPage}-${isLoggedIn}`")
    .header-user(v-if="!authPage")
        dropdown(v-if="isLoggedIn" @close="onClose" ref="dropdown" :xs="smDevice" right) {{ user.first_name }}
            template(v-slot:content)
                profile-nav.mt-5(v-if="smDevice" @click="close")
                template(v-else)
                  router-link.btn.btn-list-item(:to="{name: 'profile-general'}" active-class='active') {{ $t('profile.pages.my_account') }}
                  router-link.btn.btn-list-item(:to="{name: 'profile-orders', params: { page: 1 }}" active-class='active') {{ $t('profile.pages.order_history') }}
                  a.btn.btn-list-item(v-if="adminPortal" :href="adminPortal" target="_blank") {{ $t('profile.pages.admin_portal') }}
                template(v-if="languageSelectorAvailable")
                  .dropdown-divider
                  box.bg-transparent.language-dropdown.p-0(v-model="showLanguageSelector" @click.native.stop="" slim)
                    template(v-slot:header) {{ $t('profile.language') }}
                    button.btn-language(v-for="option in locales" @click="setLanguage(option)" :key="`lang-${option}`" :class="{'selected': option === locale}") {{$t(`base.languages.${option}`)}}
                template(v-if="smDevice")
                  .dropdown-divider
                  a.btn.btn-list-item(v-if="adminPortal" :href="adminPortal" target="_blank") {{ $t('profile.pages.admin_portal') }}
                .dropdown-divider
                button.btn.btn-list-item.btn-sm(@click="logout") {{$t('base.logout')}}
        .d-flex(v-else)
            language-selector
            router-link.btn.btn-primary(:to="{name: 'login'}" :class="{'btn-xs': smDevice}") {{$t('base.sign_up_log_in')}}
        modal-logout(ref="logout")

</template>
